




































































































import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { IAction } from "@/components/utility/mmmint/MHeader.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Appraisal, IAppraisal } from "@/models/appraisal.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import Tooltip from "../utility/tooltip.vue";
import AppraisalForm from "./AppraisalForm.vue";
import AppraisalResponseCardHistory from "./AppraisalResponseCardHistory.vue";
import AppraisalSheet from "./AppraisalSheet.vue";
import { MrfiktivAppraisalResponseDtoGen } from "@/services/mrfiktiv/v1/data-contracts";

enum CreateInvoiceWindow {
  FILE = "file",
  FIELDS = "fields"
}

enum ResponseType {
  ACCEPT,
  REQUEST,
  REJECT
}

@Component({
  components: {
    AppraisalForm,
    AppraisalResponseCardHistory,
    ConfirmActionDialog,
    DropAreaMulti,
    Tooltip,
    AppraisalSheet
  },
  filters: { simpleDoubleDigitDate }
})
export default class AppraisalResponseCard extends mixins(PermissionMixin, RulesMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;

  readonly getAutocompleteFilter = getAutocompleteFilter;

  readonly CurrencyEnum = CurrencyEnum;

  readonly CreateInvoiceWindow = CreateInvoiceWindow;

  readonly RequestStatusEnum = RequestStatusEnum;

  readonly statusIconMap = Appraisal.statusIconMap;

  readonly statusColorMap = Appraisal.statusColorMap;

  ResponseType = ResponseType;
  response: ResponseType = ResponseType.ACCEPT;

  @Prop()
  value!: IAppraisal;

  @Prop()
  token!: string;

  loadingRespondReject = false;

  loadingRequestMoreData = false;

  isRejectDialogActive = false;

  isRequestMoreDialogActive = false;

  rejectReason = "";

  requestMoreDataReason = "";

  get actions(): IAction[] {
    const actions: IAction[] = [];
    actions.push({
      text: $t("appraisal.response.makeOffer"),
      icon: Appraisal.statusIconMap.get(RequestStatusEnum.ACCEPTED),
      color: Appraisal.statusColorMap.get(RequestStatusEnum.ACCEPTED),
      loading: this.loading,
      exec: () => (this.isDialogActive = true),
      key: "makeOffer"
    });

    actions.push({
      text: $t("appraisal.response.requestMore"),
      icon: Appraisal.statusIconMap.get(RequestStatusEnum.REQUEST_MORE_DATA),
      color: Appraisal.statusColorMap.get(RequestStatusEnum.REQUEST_MORE_DATA),
      loading: this.loadingRequestMoreData,
      exec: () => (this.isRequestMoreDialogActive = true),
      key: "requestMore"
    });

    actions.push({
      text: $t("appraisal.response.reject"),
      icon: Appraisal.statusIconMap.get(RequestStatusEnum.REJECTED_BY_REQUESTED),
      color: Appraisal.statusColorMap.get(RequestStatusEnum.REJECTED_BY_REQUESTED),
      loading: this.loadingRespondReject,
      exec: () => (this.isRejectDialogActive = true),
      key: "reject"
    });

    return actions;
  }

  step = CreateInvoiceWindow.FILE;

  valueCopy = new Appraisal(this.value);

  isDialogActive = false;

  loading = false;

  isValid = false;

  file: File | null = null;

  reason = "";

  get leftText(): string {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        return $t("close");
      case CreateInvoiceWindow.FIELDS:
        return $t("back");
      default:
        return "";
    }
  }

  get rightText(): string {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        switch (this.response) {
          case ResponseType.ACCEPT:
            return $t("next");
          case ResponseType.REQUEST:
            return $t("submit");
          case ResponseType.REJECT:
            return $t("submit");
          default:
            return $t("next");
        }

      case CreateInvoiceWindow.FIELDS:
        return $t("appraisal.response.confirmOffer");
      default:
        return "";
    }
  }

  get hideRight() {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        switch (this.response) {
          case ResponseType.ACCEPT:
            return true;
          default:
            return false;
        }

      case CreateInvoiceWindow.FIELDS:
        return false;
      default:
        return false;
    }
  }

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  open() {
    this.valueCopy = new Appraisal(this.value);

    this.step = CreateInvoiceWindow.FILE;

    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
    this.isRejectDialogActive = false;
    this.isRequestMoreDialogActive = false;
  }

  rightClick() {
    if (this.step == CreateInvoiceWindow.FILE) {
      if (this.response === ResponseType.REJECT) {
        return this.respondReject();
      } else if (this.response === ResponseType.REQUEST) {
        return this.respondRequestMoreData();
      } else {
        this.step = CreateInvoiceWindow.FIELDS;
      }
    }

    if (this.step == CreateInvoiceWindow.FIELDS) {
      return this.confirmAppraisalResponse();
    }
  }

  leftClick() {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        this.close();

        break;
      case CreateInvoiceWindow.FIELDS:
        // reset form
        this.file = null;
        this.response = ResponseType.REQUEST;
        this.$nextTick(() => {
          this.response = ResponseType.ACCEPT;
        });

        this.step = CreateInvoiceWindow.FILE;
        break;
    }
  }

  async confirmAppraisalResponse() {
    if (!this.file || !this.valueCopy.title || !this.valueCopy.totalNet) {
      this.$toast.error(this.$t("appraisal.response.missingFields"));
      return;
    }

    this.loading = true;
    try {
      const dto: MrfiktivAppraisalResponseDtoGen = {
        lineItems: this.valueCopy.lineItems.map(li => li.dto),
        title: this.valueCopy.title,
        file: this.file,
        currency: this.valueCopy.currency as CurrencyEnum
      };

      if (this.valueCopy.totalLoss) {
        dto.totalLoss = this.valueCopy.totalLoss;
      }

      if (this.valueCopy.residualValueNet) {
        dto.residualValueNet = this.valueCopy.residualValueNet;
      }

      if (this.valueCopy.replacementValueNet) {
        dto.replacementValueNet = this.valueCopy.replacementValueNet;
      }

      if (this.valueCopy.diminishedValueNet) {
        dto.diminishedValueNet = this.valueCopy.diminishedValueNet;
      }

      await this.value.respondAccept(this.token, dto);

      this.$toast.success(this.$t("appraisal.response.success"));
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
      this.close();
    }
  }

  async respondRequestMoreData() {
    this.loadingRequestMoreData = true;
    try {
      await this.value.respondReject(this.token, {
        status: RequestStatusEnum.REQUEST_MORE_DATA,
        message: this.requestMoreDataReason || undefined
      });
    } catch (error) {
      handleError(error);
    } finally {
      this.$toast.success(this.$t("appraisal.response.successReject"));
      this.loadingRequestMoreData = false;
      this.close();
    }
  }

  async respondReject() {
    this.loadingRespondReject = true;
    try {
      await this.value.respondReject(this.token, {
        status: RequestStatusEnum.REJECTED_BY_REQUESTED,
        message: this.rejectReason || undefined
      });
    } catch (error) {
      handleError(error);
    } finally {
      this.$toast.success(this.$t("appraisal.response.successReject"));
      this.loadingRespondReject = false;
      this.close();
    }
  }

  @Watch("file", { deep: true })
  onFileChange(file: File) {
    if (file && file.name.endsWith(".pdf")) {
      if (!this.valueCopy.title) {
        this.valueCopy.title = file.name
          .substring(0, file.name.length - 4)
          .replace(/\s+/g, "")
          .replace(/[^\w\d-]/g, "");
      }
      this.step = CreateInvoiceWindow.FIELDS;
      this.$nextTick(() => {
        (this.$refs.startField as HTMLInputElement)?.focus();
      });
    }
  }
}
